import React, { Component } from 'react';
import { Form } from 'antd';
import { language } from '../../../language';
import { FormItemLayout, ConfigFormDecorator, NumberInput } from '../../tools';

const FormItem = Form.Item;

/**
 * 辅助空白组件-配置表单
 */
class space extends Component<any> {
    render() {
        const {
            form: { getFieldDecorator },
        } = this.props;
        const formItemLayout = FormItemLayout;
        return (
            <Form className="space-form">
                <FormItem {...formItemLayout} label={language.getText('components.Space.space')}>
                    {getFieldDecorator('height')(<NumberInput min={1} />)}
                </FormItem>
            </Form>
        );
    }
}

export const Space = ConfigFormDecorator(space);
